import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {ThemingService} from "../../theming.service";
import {TenantSelectorService} from "../../services/tenant-selector.service";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {ConfigsLoaderService} from "../../services/config-loader.service";
import {ThemeConfig} from "../../theme-config";
import {DEFAULT_THEME} from "../../default-theme";
import {AppRoutePaths} from "../../enums/routes.enum";
import {ToastService} from "../../services/toast.service";

@Injectable({providedIn: 'root'})
export class LoadClientThemeGuard implements CanActivate {
  constructor(
    private themingService: ThemingService,
    private router: Router,
    private httpClient: HttpClient,
    private config: ConfigsLoaderService,
    private tenantSelectorService: TenantSelectorService,
    private toast: ToastService,
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (route.paramMap.has('tenantId')) {
      const tenantId = route.paramMap.get('tenantId');
      this.tenantSelectorService.selectTenant({id: tenantId, description: 'TenantPlaceholder'})
      let tenantTheme: ThemeConfig
      try {
        tenantTheme = await this.httpClient.get<{ jsonTheme: string }>(`${this.config.apiUrl}/Tenant`)
          .pipe(
            map(themeObj => JSON.parse(themeObj?.jsonTheme))
          ).toPromise();
      } catch (err) {
        if (err === 'errors.No Content') { // If the tenant doesn't exists
          this.toast.error("Portal no encontrado");
          return this.router.parseUrl(`/${AppRoutePaths.SELECT_TENANTS}`);
        }
        tenantTheme = DEFAULT_THEME;
      }
      await this.themingService.loadClientTheme(tenantTheme)
      return true;
    } else {
      return this.router.parseUrl(`/${AppRoutePaths.SELECT_TENANTS}`);
    }
  }
}
